import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import "./QA.css";
import TaxCalculator from "../TaxCalculator/TaxCalculator";
import { FaCalculator, FaQuestionCircle, FaInfoCircle } from 'react-icons/fa';

const QA = ({ title, description, link, linkName, openTaxCalculator }) => {



    const getIcon = (title) => {
        switch (title.toLowerCase()) {
            case 'მოსაკრებელის კალკულატორი':
                return <FaCalculator className="icon" />;
            case 'ხშირად დასმული კითხვები':
                return <FaQuestionCircle className="icon" />;
            case 'სასარგებლო ინფორმაცია':
                return <FaInfoCircle className="icon" />;
            default:
                return null;
        }
    };

    return (
        <div  className="qa-container">
            <div className="qa-line"></div>
            <div className="qa-title">
                {getIcon(title)}
                {title}
            </div>
            <div className="qa-description">{description}</div>
            {openTaxCalculator ? (
                <TaxCalculator  />
            ) : (
                <Link className="qa-link" to={link} style={{ textDecoration: 'none' }}>
                    {linkName}
                </Link>
            )}
        </div>
    );
};

export default QA;
